import { Component } from '@angular/core';
import { Events } from 'ionic-angular';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';


const DEFAULTVALUE = 0;
@Component({
  selector: 'azure-upload',
  templateUrl: 'azure-upload.html'
})
export class AzureUploadComponent {
  broadcastSubs: any;
  constructor(public event: Events, public dataService: DataServiceProvider, public communicationServ: CommunicationServiceProvider) {
  }
  ngOnInit() {
    this.dataService.sheetName = 'AZURE';
    this.initAzureData();
    var jsonData = JSON.parse(localStorage.getItem('AZURE_EXCEL_DATA'));
    if (jsonData != null) {
      this.AzureData(jsonData);
    }
  }
  initAzureData() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "proposal-create") {
          if (data.event === 'loadAzureData') {
            let rowData = data['params'];
            let excelArr = rowData["Azure Production and DR"];
            excelArr.splice(0, 1);
            const resultArray = excelArr.map(elm => ({
              serviceType: elm['Microsoft Azure Estimate'],
              customName: elm['__EMPTY'],
              region: elm['__EMPTY_1'],
              description: elm['__EMPTY_2'],
              sku: elm['__EMPTY_3'],
              resource: elm['__EMPTY_4'],
              estimatedMonthlyCost: elm['__EMPTY_5'],
              estimatedUpfrontCost: elm['__EMPTY_6']
            }));
            localStorage.setItem('AZURE_EXCEL_DATA', JSON.stringify(resultArray));
            this.AzureData(resultArray);
          }
          else if (data.event == 'AzureMarkup') {
            this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureMarkup = data['params'];
            var jsonData = JSON.parse(localStorage.getItem('AZURE_EXCEL_DATA'));
            if (jsonData != null) {
              this.AzureData(jsonData);
            }
          }
        }
      })
  }
  AzureData(data) {
    this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureTable = [];
    data.forEach(element => {
      if (element.estimatedMonthlyCost != undefined) {
        let type = typeof element.estimatedMonthlyCost;
        if (type == 'number') {
          let price = '$' + (element.estimatedMonthlyCost + (element.estimatedMonthlyCost * (this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureMarkup != '' ? (parseFloat(this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureMarkup.slice(0, -1)) / 100) : 0))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          let obj = {
            "serviceType": element.serviceType != undefined ? element.serviceType : '',
            "customName": element.customName != undefined ? element.customName : '',
            "region": element.region != undefined ? element.region : '',
            "description": element.description != undefined ? element.description : '',
            "price": price
          }
          if (element.resource != undefined && element.resource.toLowerCase() == 'total') {
          } else {
            this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureTable.push(obj);
          }
        }
      }
    });
    this.SubTotalAzure();
  }

  SubTotalAzure() {
    var sumArray = [];
    this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureTable.forEach(element => {
      sumArray.push(parseFloat(element.price.slice(1).replace(/  |,/gi, "")));
    });
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if (value != DEFAULTVALUE) {
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureSubTotal = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let taxVal = value * 0.13;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureTax = '$' + taxVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let totalVal = value + taxVal;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureMonthly = '$' + totalVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureSubTotal = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureTax = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureMonthly = '';
    }
    localStorage.setItem('CLOUDScreenData', JSON.stringify(this.dataService.ProposalTable.cloudPricingSheet));
  }
  ngOnDestroy() {
    this.dataService.sheetName = '';
    this.broadcastSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/azure-upload/azure-upload.ts